import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {


  @Input()
  adminBreadcrumb: boolean = false

  menuItems: { name: string, url: string }[] = []

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {

  }
  ngOnInit(): void {
    //calculate the current route
    this.menuItems = this.createBreadcrumbs(this.activatedRoute.root)
   
    //register current events
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.menuItems = this.createBreadcrumbs(this.activatedRoute.root)
       
      });

  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: { name: string, url: string }[] = []): { name: string, url: string }[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }
      //console.log("The routeURL = "+url)
      //const label = child.snapshot.data[BreadcrumbComponent.ROUTE_DATA_BREADCRUMB];
      const label = child.snapshot.data["breadcrumb"]
      if (label != null) {
        //push only if not present
        if (breadcrumbs.filter(p => p.name == label).length == 0) {
          breadcrumbs.push({ name: label, url: url });
        }

      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
    return []
  }

  isLastMenu(i: string): boolean {
    return i == this.menuItems[this.menuItems.length - 1].name

  }

}
